import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './App.css';

import User from './User';
import Table from './Table';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route exact path="/" render={(props) => <User {...props}/>}/>
          <Route exact path="/table" render={(props) => <Table {...props} id="5555"/>}/>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js